/* eslint-disable react/no-multi-comp */
import { h, Component } from 'preact';
import { Router, route } from 'preact-router';
import Axios from 'axios';
import qs from 'query-string';

import logicInit from '../logic';

// Code-splitting is automated for routes
import PreBrokerChooser from '../routes/PreBrokerChooser';
import BrokerChooser from '../routes/BrokerChooser';
import SingleBrokerLogin from '../routes/SingleBrokerLogin';
import PreConnect from '../routes/PreConnect';
import BrokerConnected from '../routes/BrokerConnected';
import Placeholder from '../routes/Placeholder';
import VerifyingLogin from '../routes/VerifyingLogin';
import OrderCancelled from '../routes/OrderCancelled/OrderCancelled';
import LoginFailed from '../routes/LoginFailed';
import OrderflowWaiting from '../routes/OrderflowWaiting';
import OrderInQueue from '../routes/OrderInQueue';
import EmptyBg from '../routes/EmptyBg';
import HoldingsFetch from '../routes/HoldingsFetch';
import SmallcaseLoader from '../routes/SmallcaseLoader';
import Error from '../routes/Error';

import store from '../utils/store';

const brokerConfigURL = `https://config.smallcase.com/brokerconfig/${ENV}/brokerConfig.json`;

const copyConfigURL = `https://config.smallcase.com/gateway/copyConfig/${ENV}/copyConfig.json`;


class Redirect extends Component {
  componentWillMount() {
    route(this.props.to, true);
  }

  render() {
    return null;
  }
}


export default class App extends Component {
  constructor(props) {
    super(props);
    this.state = {
      loading: true,
      gatewayName: 'Merchant',
    };
    if (typeof window !== 'undefined') {
      const params = qs.parse(window.location.search);
      this.gateway = params.gateway || 'default';
      window.updateGatewayName = (gatewayName) => {
        this.setState({
          gatewayName,
        });
      };

      if (params.deviceType) store.deviceType = params.deviceType;
      if (params.deviceType === 'ios' || params.deviceType === 'android') store.isMobileDevice = true;
    }
  }

  componentDidMount() {
    let noSWPromise = Promise.resolve(true);
    if (window.navigator.serviceWorker) {
      noSWPromise = window.navigator.serviceWorker.getRegistrations().then((registrations) => {
        for (const registration of registrations) {
          registration.unregister();
        }
      }).catch(err => err);
    }

    noSWPromise.then(() => {
      const fetchBrokerConfig = Axios.get(brokerConfigURL)
        .then(res => res.data)
        .then((brokers) => {
          this.brokerMap = brokers;
        });
      const fetchCopy = Axios.get(copyConfigURL)
        .then(res => res.data)
        .then((copies) => {
          this.copies = copies;
        });
      Promise.all([fetchBrokerConfig, fetchCopy])
        .then(() => {
          this.setState({
            loading: false,
          });
        });
      logicInit();
    });
  }

  /** Gets fired when the route changes.
    * @param {Object} event "change" event from [preact-router](http://git.io/preact-router)
    * @param {string} event.url The newly routed URL
    */
  render() {
    const copy = this.copies && (this.copies[this.gateway] || this.copies['default']);
    return (
      <div id="app">
        <Router>
          <BrokerChooser
            path="/connect"
            brokerMap={this.brokerMap}
            copies={copy}
            gateway={this.gateway}
            deviceType={this.state.deviceType}
          />
          <PreBrokerChooser
            path="/pre-broker-chooser"
            copies={copy}
          />
          <PreConnect
            path="/pre-connect"
            brokerMap={this.brokerMap}
            copies={copy}
            loading={this.state.loading}
          />
          <BrokerConnected
            path="/post-connect"
            brokerMap={this.brokerMap}
            copies={copy}
            loading={this.state.loading}
          />
          <HoldingsFetch
            path="/holding-import"
            brokerMap={this.brokerMap}
            copies={copy}
            loading={this.state.loading}
          />
          <Placeholder
            path="/waiting"
          />
          <VerifyingLogin
            path="/verifying-login"
            brokerMap={this.brokerMap}
            copies={copy}
            loading={this.state.loading}
          />
          <OrderCancelled
            path="/order-cancelled"
            copies={copy}
            brokerMap={this.brokerMap}
            loading={this.state.loading}
          />
          <LoginFailed
            path="/login-failed"
            copies={copy}
            brokerMap={this.brokerMap}
            loading={this.state.loading}
          />
          <SingleBrokerLogin
            path="/click-to-continue"
            copies={copy}
            brokerMap={this.brokerMap}
            loading={this.state.loading}
            gatewayName={this.state.gatewayName}
          />
          <OrderflowWaiting
            path="/orderflow-waiting"
            copies={copy}
            brokerMap={this.brokerMap}
            loading={this.state.loading}
          />
          <OrderInQueue
            path="/order-in-queue"
            copies={copy}
            loading={this.state.loading}
          />
          <SmallcaseLoader
            path="/smallcase-loader"
          />
          <Error
            path="/error"
          />
          <EmptyBg path="/empty" />
          <Redirect path="/" to="/empty" />
        </Router>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./components/app.js